import {
	AiOutlineDoubleRight,
	AiOutlineDoubleLeft,
	AiOutlineMenu,
	AiOutlinePlus,
	AiOutlineShareAlt,
} from 'react-icons/ai';
import { FiLogOut } from 'react-icons/fi';
import { IoMdSettings } from 'react-icons/io';
import { BsFillEyeFill, BsDownload, BsSend } from 'react-icons/bs';
import { MdOutlineDragHandle } from 'react-icons/md';
import { RxCaretSort } from 'react-icons/rx';
import { BiEdit } from 'react-icons/bi';
import { RiDeleteBin5Line } from 'react-icons/ri';
import { ImEye } from 'react-icons/im';
import { IoFootstepsOutline } from 'react-icons/io5';
import { FiCopy } from 'react-icons/fi';
import { AiOutlineUser } from 'react-icons/ai';
import { CiLocationOn } from 'react-icons/ci';
import { IoSchoolOutline } from 'react-icons/io5';
import { TfiEmail } from 'react-icons/tfi';
import { AiFillLock } from 'react-icons/ai';
import { BsFillMicFill } from 'react-icons/bs';
import { BsStopCircleFill } from 'react-icons/bs';
import { AiOutlinePlayCircle } from 'react-icons/ai';
import { AiOutlinePauseCircle } from 'react-icons/ai';
interface IconProps {
	color?: string;
	size?: number;
}

const MicIcon = ({ color = 'black', size = 25 }: IconProps) => {
	return <BsFillMicFill color={color} size={size} />;
};

const StopIcon = ({ color = 'black', size = 25 }: IconProps) => {
	return <BsStopCircleFill color={color} size={size} />;
};

const PlayIcon = ({ color = 'black', size = 25 }: IconProps) => {
	return <AiOutlinePlayCircle color={color} size={size} />;
};

const PauseIcon = ({ color = 'black', size = 25 }: IconProps) => {
	return <AiOutlinePauseCircle color={color} size={size} />;
};

const ShareIcon = ({ color = 'black', size = 25 }: IconProps) => {
	return <AiOutlineShareAlt color={color} size={size} />;
};
const UserIcon = ({ color = 'black', size = 25 }: IconProps) => {
	return <AiOutlineUser color={color} size={size} />;
};
const LocationIcon = ({ color = 'black', size = 25 }: IconProps) => {
	return <CiLocationOn color={color} size={size} />;
};
const SchoolIcon = ({ color = 'black', size = 25 }: IconProps) => {
	return <IoSchoolOutline color={color} size={size} />;
};
const EmailIcon = ({ color = 'black', size = 25 }: IconProps) => {
	return <TfiEmail color={color} size={size} />;
};
const LockIcon = ({ color = 'black', size = 25 }: IconProps) => {
	return <AiFillLock color={color} size={size} />;
};
const SendIcon = ({ color = 'black', size = 25 }: IconProps) => {
	return <BsSend color={color} size={size} />;
};
const CopyIcon = ({ color = 'black', size = 25 }: IconProps) => {
	return <FiCopy color={color} size={size} />;
};

const ViewIcon = ({ color = 'black', size = 25 }: IconProps) => {
	return <ImEye color={color} size={size} />;
};
const DeleteIcon = ({ color = 'black', size = 25 }: IconProps) => {
	return <RiDeleteBin5Line color={color} size={size} />;
};
const EditIcon = ({ color = 'black', size = 25 }: IconProps) => {
	return <BiEdit color={color} size={size} />;
};
const RightArrow = ({ color = 'black', size = 25 }: IconProps) => {
	return <AiOutlineDoubleRight color={color} size={size} />;
};

const LeftArrow = ({ color = 'black', size = 25 }: IconProps) => {
	return <AiOutlineDoubleLeft color={color} size={size} />;
};

const MenuIcon = ({ color = 'black', size = 25 }: IconProps) => {
	return <AiOutlineMenu color={color} size={size} />;
};

const LogoutIcon = ({ color = 'black', size = 25 }: IconProps) => {
	return <FiLogOut color={color} size={size} />;
};

const EyeIcon = ({ color = 'black', size = 25 }: IconProps) => {
	return <BsFillEyeFill color={color} size={size} />;
};

const DownloadIcon = ({ color = 'black', size = 25 }: IconProps) => {
	return <BsDownload color={color} size={size} />;
};

const DargIcon = ({ color = 'black', size = 25 }: IconProps) => {
	return <MdOutlineDragHandle color={color} size={size} />;
};

const SortIcon = ({ color = 'black', size = 25 }: IconProps) => {
	return <RxCaretSort color={color} size={size} />;
};
const StepIcon = ({ color = 'black', size = 25 }: IconProps) => {
	return <IoFootstepsOutline color={color} size={size} />;
};

const HomeIcon = ({ color = 'white', size = 25 }: IconProps) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 18 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M17.3641 8.1758L9.67889 0.295798C9.58623 0.20207 9.47598 0.127676 9.35452 0.0769069C9.23305 0.0261382 9.10276 0 8.97118 0C8.83959 0 8.7093 0.0261382 8.58784 0.0769069C8.46637 0.127676 8.35612 0.20207 8.26346 0.295798L0.57825 8.1858C0.392287 8.37387 0.245418 8.59712 0.146172 8.84261C0.0469255 9.08809 -0.002721 9.35091 0.000114993 9.6158V17.9958C-0.000657339 18.5077 0.194262 19.0004 0.544733 19.3725C0.895204 19.7446 1.37454 19.9676 1.88404 19.9958H16.0583C16.5678 19.9676 17.0471 19.7446 17.3976 19.3725C17.7481 19.0004 17.943 18.5077 17.9422 17.9958V9.6158C17.943 9.07873 17.7357 8.56238 17.3641 8.1758ZM6.97761 17.9958V11.9958H10.9647V17.9958H6.97761ZM15.9487 17.9958H12.9583V10.9958C12.9583 10.7306 12.8533 10.4762 12.6664 10.2887C12.4794 10.1012 12.2259 9.9958 11.9615 9.9958H5.98082C5.71646 9.9958 5.46292 10.1012 5.27599 10.2887C5.08906 10.4762 4.98404 10.7306 4.98404 10.9958V17.9958H1.99368V9.5758L8.97118 2.4258L15.9487 9.6158V17.9958Z"
				fill={color}
			/>
		</svg>
	);
};

const SettingsIcon = ({ color = 'white', size = 25 }: IconProps) => {
	return <IoMdSettings color={color} size={size} />;
};

const PlusIcon = ({ color = 'white', size = 25 }: IconProps) => {
	return <AiOutlinePlus color={color} size={size} />;
};

const HomeworkIcon = ({ color = 'white', size = 25 }: IconProps) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 19 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M9.24614 12.2145V12.6832C9.24614 12.845 9.37731 12.9762 9.53911 12.9762C9.7009 12.9762 9.83207 12.845 9.83207 12.6832V12.2145C9.83207 12.0527 9.7009 11.9215 9.53911 11.9215C9.37731 11.9215 9.24614 12.0527 9.24614 12.2145ZM9.12681 5.56572C8.96501 5.56572 8.83384 5.69689 8.83384 5.85868V6.5018H8.16818C8.00639 6.5018 7.87522 6.63297 7.87522 6.79477C7.87522 6.95656 8.00639 7.08773 8.16818 7.08773H8.83384V7.75335C8.83384 7.91514 8.96501 8.04631 9.12681 8.04631C9.2886 8.04631 9.41977 7.91514 9.41977 7.75335V7.08773H10.0628C10.2246 7.08773 10.3558 6.95656 10.3558 6.79477C10.3558 6.63297 10.2246 6.5018 10.0628 6.5018H9.41977V5.85868C9.41977 5.69689 9.2886 5.56572 9.12681 5.56572ZM3.40777 12.2145V12.6832C3.40777 12.845 3.53894 12.9762 3.70074 12.9762C3.86253 12.9762 3.9937 12.845 3.9937 12.6832V12.2145C3.9937 12.0527 3.86253 11.9215 3.70074 11.9215C3.53894 11.9215 3.40777 12.0527 3.40777 12.2145ZM17.8972 10.8443L16.8403 9.78739C16.4255 9.37247 15.7504 9.37251 15.3354 9.78739L13.2398 11.883V5.65228C13.2398 2.5356 10.7042 0 7.58757 0H2.60509C2.44329 0 2.31212 0.13117 2.31212 0.292965C2.31212 0.45476 2.44329 0.585931 2.60509 0.585931H7.58757C8.75333 0.585931 8.75333 1.15835 8.75333 1.71189V3.05805C8.75333 3.84574 9.39415 4.48651 10.1818 4.48651H11.5279C12.0815 4.48651 12.6539 4.48651 12.6539 5.65228V12.469C8.84072 16.2822 8.95572 16.1392 8.69345 16.5232H1.42846C0.963895 16.5232 0.585931 16.1453 0.585931 15.6807V1.42846C0.585931 1.02175 0.875615 0.673235 1.27475 0.599876C1.43389 0.570579 1.53916 0.417886 1.5099 0.258747C1.48061 0.0996082 1.32787 -0.00562494 1.16878 0.0235935C0.491557 0.148162 0 0.738976 0 1.42846V15.6807C0 16.4684 0.640813 17.1092 1.42846 17.1092H8.36533C8.29111 17.2753 8.30037 17.2669 7.75436 18.6557C7.60952 19.0253 7.69393 19.4293 7.97463 19.71C8.25104 19.9864 8.6538 20.0772 9.02892 19.9302L10.4097 19.3891C11.3993 19.0013 11.837 18.3742 12.1226 18.1237L12.6186 17.6278C12.733 17.5134 12.733 17.3278 12.6186 17.2134C12.5041 17.099 12.3186 17.099 12.2043 17.2134L11.9156 17.5021L10.1825 15.769C10.694 15.2575 13.1956 12.7559 13.5816 12.37L15.3147 14.1031L13.1961 16.2217C13.0816 16.3361 13.0816 16.5216 13.1961 16.636C13.3105 16.7504 13.496 16.7504 13.6103 16.636L17.8972 12.3491C18.3121 11.9342 18.3121 11.2591 17.8972 10.8443ZM11.5279 3.90058H10.1818C9.71723 3.90058 9.33926 3.52262 9.33926 3.05805C9.33883 1.51971 9.36833 1.24163 9.21813 0.855186C10.7023 1.36104 11.8788 2.53755 12.3847 4.02171C12.0744 3.90113 11.744 3.90058 11.5279 3.90058ZM8.81513 19.3847C8.66349 19.4441 8.50412 19.4108 8.38892 19.2957C8.27373 19.1805 8.24045 19.0211 8.2999 18.8695L8.59236 18.1232C8.99845 18.329 9.34817 18.6716 9.56141 19.0922L8.81513 19.3847ZM11.5013 17.9164L11.2902 18.1275C10.7415 18.6762 10.1605 18.8518 10.1096 18.8774C9.84 18.3167 9.3688 17.845 8.80716 17.575C8.82915 17.5367 8.99946 16.952 9.55707 16.3944L9.76817 16.1833L11.5013 17.9164ZM15.729 13.6887L13.9958 11.9556L14.6499 11.3016L16.383 13.0348L15.729 13.6887ZM17.4829 11.9348L16.7973 12.6204L15.0642 10.8873L15.7498 10.2017C15.9362 10.0153 16.2396 10.0153 16.4261 10.2017L17.4829 11.2585C17.6693 11.445 17.6693 11.7484 17.4829 11.9348ZM5.69864 4.34108C5.55529 3.99269 5.05935 4.00171 4.92783 4.34851L2.90317 9.66442C2.84559 9.81563 2.92145 9.98489 3.07266 10.0425C3.22379 10.1 3.39312 10.0241 3.4507 9.87297L3.88308 8.73771H6.73168L7.1598 9.87215C7.2173 10.0245 7.38691 10.0996 7.53733 10.0428C7.68874 9.98571 7.76514 9.81665 7.70799 9.66528C5.62239 4.1389 5.70204 4.34948 5.69864 4.34108ZM4.10628 8.15178L5.31396 4.98092L6.51059 8.15178H4.10628ZM7.40687 12.2836C7.19406 12.1757 6.93836 12.1536 6.61992 12.1536C6.30149 12.1536 6.04579 12.1757 5.83298 12.2836C5.63611 12.3835 5.40142 12.6013 5.40142 13.0722C5.40142 13.8048 5.94805 14.4009 6.61992 14.4009C7.29179 14.4009 7.83838 13.8048 7.83838 13.0722C7.83838 12.6013 7.60374 12.3835 7.40687 12.2836ZM6.61992 13.8149C6.27114 13.8149 5.98735 13.4818 5.98735 13.0722C5.98735 12.8415 6.01294 12.7395 6.61992 12.7395C7.22691 12.7395 7.25245 12.8415 7.25245 13.0722C7.25245 13.4818 6.96871 13.8149 6.61992 13.8149Z"
				fill={color}
			/>
		</svg>
	);
};

const ExamIcon = ({ color = 'white', size = 25 }: IconProps) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M6.6405 3.125H11.7968C12.0125 3.125 12.1874 2.95012 12.1874 2.73438C12.1874 2.51863 12.0125 2.34375 11.7968 2.34375H6.6405C6.42476 2.34375 6.24988 2.51863 6.24988 2.73438C6.24988 2.95012 6.42476 3.125 6.6405 3.125Z"
				fill={color}
			/>
			<path
				d="M11.7968 3.95831H8.39819C8.18245 3.95831 8.00757 4.1332 8.00757 4.34894C8.00757 4.56468 8.18245 4.73956 8.39819 4.73956H11.7968C12.0126 4.73956 12.1875 4.56468 12.1875 4.34894C12.1875 4.1332 12.0126 3.95831 11.7968 3.95831Z"
				fill={color}
			/>
			<path
				d="M10 12.0312H6.64062C6.42488 12.0312 6.25 12.2061 6.25 12.4219C6.25 12.6376 6.42488 12.8125 6.64062 12.8125H10C10.2158 12.8125 10.3907 12.6376 10.3907 12.4219C10.3907 12.2061 10.2158 12.0312 10 12.0312Z"
				fill={color}
			/>
			<path
				d="M11.7968 5.57294H6.6405C6.42476 5.57294 6.24988 5.74782 6.24988 5.96356C6.24988 6.1793 6.42476 6.35419 6.6405 6.35419H11.7968C12.0125 6.35419 12.1874 6.1793 12.1874 5.96356C12.1874 5.74782 12.0126 5.57294 11.7968 5.57294Z"
				fill={color}
			/>
			<path
				d="M6.6405 4.73956C6.85624 4.73956 7.03112 4.56468 7.03112 4.34894C7.03112 4.1332 6.85624 3.95831 6.6405 3.95831H6.64022C6.42448 3.95831 6.24976 4.1332 6.24976 4.34894C6.24976 4.56468 6.42476 4.73956 6.6405 4.73956V4.73956Z"
				fill={color}
			/>
			<path
				d="M6.6405 7.96875H9.99992C10.2157 7.96875 10.3905 7.79387 10.3905 7.57812C10.3905 7.36238 10.2157 7.1875 9.99992 7.1875H6.6405C6.42476 7.1875 6.24988 7.36238 6.24988 7.57812C6.24988 7.79387 6.42476 7.96875 6.6405 7.96875Z"
				fill={color}
			/>
			<path
				d="M11.7968 8.80206H6.6405C6.42476 8.80206 6.24988 8.97695 6.24988 9.19269C6.24988 9.40843 6.42476 9.58331 6.6405 9.58331H11.7968C12.0125 9.58331 12.1874 9.40843 12.1874 9.19269C12.1874 8.97695 12.0126 8.80206 11.7968 8.80206Z"
				fill={color}
			/>
			<path
				d="M11.7968 10.4167H6.6405C6.42476 10.4167 6.24988 10.5916 6.24988 10.8073C6.24988 11.0231 6.42476 11.1979 6.6405 11.1979H11.7968C12.0125 11.1979 12.1874 11.0231 12.1874 10.8073C12.1874 10.5916 12.0126 10.4167 11.7968 10.4167Z"
				fill={color}
			/>
			<path
				d="M15.7031 11.4063C15.5714 11.4063 15.4412 11.4126 15.3125 11.4242V1.95316C15.3125 1.42921 15.1069 0.93652 14.7336 0.565857C14.3658 0.200624 13.8805 0 13.3685 0C13.3639 0 13.3592 0 13.3546 3.90623e-05H1.95386C1.95363 3.90623e-05 1.95335 3.90623e-05 1.95312 3.90623e-05C0.876168 3.90623e-05 0 0.876208 0 1.95316V2.7344C0 2.95014 0.174882 3.12503 0.390623 3.12503H3.12495H3.12499V16.4323C3.12499 17.5093 4.00116 18.3854 5.07811 18.3854H12.3489C13.137 19.3689 14.3477 20 15.7031 20C18.0724 20 20 18.0724 20 15.7031C20 13.3339 18.0724 11.4063 15.7031 11.4063V11.4063ZM3.12499 2.34374H0.781247V1.95312C0.781247 1.30703 1.30679 0.781403 1.95288 0.781247H1.95312H1.95386C2.59972 0.781716 3.12499 1.30722 3.12499 1.95316V2.34374ZM6.24998 16.4323C6.24998 17.0784 5.72427 17.6041 5.07811 17.6041C4.43194 17.6041 3.90623 17.0784 3.90623 16.4323V1.95316C3.90623 1.51382 3.76034 1.10796 3.51456 0.781286H13.3574C13.6673 0.779645 13.9608 0.89945 14.1831 1.12019C14.4076 1.34312 14.5312 1.63894 14.5312 1.95316V11.5687C13.4056 11.8882 12.4667 12.6562 11.9206 13.6662C11.8817 13.6532 11.8401 13.6458 11.7969 13.6458H6.64056C6.42482 13.6458 6.24994 13.8207 6.24994 14.0365C6.24994 14.2522 6.42482 14.4271 6.64056 14.4271H11.5997C11.5163 14.6947 11.4585 14.9734 11.4289 15.2604H6.64056C6.53697 15.2604 6.43759 15.3016 6.36435 15.3748C6.29111 15.4481 6.24994 15.5474 6.24994 15.651L6.24998 16.4323ZM6.63966 17.6041C6.8854 17.2775 7.03118 16.8716 7.03118 16.4323V16.0417H11.4196C11.4632 16.5989 11.6138 17.1265 11.8504 17.6042H6.63966V17.6041ZM15.7031 19.2188C13.7646 19.2188 12.1875 17.6417 12.1875 15.7031C12.1875 13.7646 13.7646 12.1875 15.7031 12.1875C17.6417 12.1875 19.2188 13.7646 19.2188 15.7031C19.2188 17.6417 17.6417 19.2188 15.7031 19.2188Z"
				fill={color}
			/>
			<path
				d="M17.9908 13.9212C17.5339 13.4643 16.7905 13.4644 16.3337 13.9212L15.2556 14.9994L15.0724 14.8162C14.851 14.5948 14.5568 14.4729 14.2438 14.4729C13.9308 14.4729 13.6365 14.5948 13.4152 14.8161C12.9583 15.273 12.9583 16.0164 13.4152 16.4733L14.427 17.4851C14.6554 17.7135 14.9555 17.8278 15.2556 17.8278C15.5556 17.8278 15.8557 17.7135 16.0842 17.4851L17.9909 15.5784C18.2122 15.3571 18.3341 15.0628 18.3341 14.7498C18.3341 14.4368 18.2122 14.1425 17.9908 13.9212V13.9212ZM17.4384 15.0259L15.5317 16.9326C15.3795 17.0849 15.1316 17.0849 14.9794 16.9326L13.9676 15.9208C13.8153 15.7686 13.8153 15.5208 13.9676 15.3685C14.0413 15.2947 14.1394 15.2542 14.2437 15.2542C14.3481 15.2542 14.4461 15.2948 14.5199 15.3685L14.9793 15.828C15.1318 15.9805 15.3791 15.9805 15.5317 15.828L16.8861 14.4736C17.0383 14.3214 17.2861 14.3214 17.4384 14.4736C17.5122 14.5474 17.5527 14.6455 17.5527 14.7497C17.5528 14.8541 17.5122 14.9522 17.4384 15.0259V15.0259Z"
				fill={color}
			/>
		</svg>
	);
};

const GroupIcon = ({ color = 'white', size = 25 }: IconProps) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 27 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M13.4999 0C11.2343 0 9.39124 1.84302 9.39124 4.10871C9.39124 6.3744 11.2343 8.21743 13.4999 8.21743C15.7656 8.21743 17.6087 6.37434 17.6087 4.10871C17.6087 1.84308 15.7656 0 13.4999 0ZM13.4999 7.04347C11.8823 7.04347 10.5652 5.72635 10.5652 4.10871C10.5652 2.49108 11.8823 1.17395 13.4999 1.17395C15.1176 1.17395 16.4347 2.49108 16.4347 4.10871C16.4347 5.72635 15.1176 7.04347 13.4999 7.04347Z"
				fill={color}
			/>
			<path
				d="M21.7174 4.69568C20.0997 4.69568 18.7826 6.01281 18.7826 7.63044C18.7826 9.24807 20.0997 10.5652 21.7174 10.5652C23.335 10.5652 24.6521 9.24807 24.6521 7.63044C24.6521 6.01281 23.335 4.69568 21.7174 4.69568ZM21.7174 9.39131C20.7465 9.39131 19.9565 8.60129 19.9565 7.63044C19.9565 6.6596 20.7465 5.86957 21.7174 5.86957C22.6882 5.86957 23.4782 6.6596 23.4782 7.63044C23.4782 8.60129 22.6882 9.39131 21.7174 9.39131Z"
				fill={color}
			/>
			<path
				d="M5.36592 4.69568C3.74707 4.69568 2.43115 6.01281 2.43115 7.63044C2.43115 9.24807 3.74828 10.5652 5.36592 10.5652C6.98355 10.5652 8.30068 9.24807 8.30068 7.63044C8.30068 6.01281 6.98471 4.69568 5.36592 4.69568ZM5.36592 9.39131C4.39507 9.39131 3.60505 8.60129 3.60505 7.63044C3.60505 6.6596 4.39507 5.86957 5.36592 5.86957C6.33676 5.86957 7.12679 6.6596 7.12679 7.63044C7.12679 8.60129 6.33671 9.39131 5.36592 9.39131Z"
				fill={color}
			/>
			<path
				d="M13.5 9.39136C9.29264 9.39136 5.86951 12.8145 5.86951 17.0218C5.86951 17.3458 6.13248 17.6088 6.45648 17.6088C6.78048 17.6088 7.04346 17.3458 7.04346 17.0218C7.04346 13.4613 9.93948 10.5653 13.5 10.5653C17.0604 10.5653 19.9565 13.4613 19.9565 17.0218C19.9565 17.3458 20.2194 17.6088 20.5434 17.6088C20.8674 17.6088 21.1304 17.3458 21.1304 17.0218C21.1304 12.8145 17.7073 9.39136 13.5 9.39136Z"
				fill={color}
			/>
			<path
				d="M21.7174 11.7391C20.7513 11.7391 19.8051 12.0033 18.981 12.5022C18.7052 12.6712 18.6159 13.0316 18.7838 13.3087C18.954 13.5857 19.3132 13.6738 19.5903 13.5059C20.23 13.1173 20.9649 12.913 21.7174 12.913C23.983 12.913 25.8261 14.756 25.8261 17.0217C25.8261 17.3457 26.0891 17.6087 26.4131 17.6087C26.7371 17.6087 27.0001 17.3457 27.0001 17.0217C27 14.1093 24.6299 11.7391 21.7174 11.7391Z"
				fill={color}
			/>
			<path
				d="M8.01784 12.501C7.19491 12.0033 6.24877 11.7391 5.2826 11.7391C2.37013 11.7391 0 14.1093 0 17.0217C0 17.3457 0.262975 17.6087 0.586974 17.6087C0.910974 17.6087 1.17395 17.3457 1.17395 17.0217C1.17389 14.756 3.01697 12.913 5.2826 12.913C6.0351 12.913 6.76993 13.1173 7.40858 13.5047C7.68443 13.6726 8.04601 13.5845 8.21505 13.3075C8.3841 13.0304 8.29484 12.67 8.01784 12.501Z"
				fill={color}
			/>
		</svg>
	);
};

const CompetitonIcon = ({ color = 'white', size = 25 }: IconProps) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 19 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M16.4257 15.6796L15.0172 15.2661L11.9527 13.2645V12.8058C12.8399 12.1366 13.4492 11.1136 13.5624 9.94107C14.0074 9.86945 14.3483 9.48277 14.3483 9.01796V7.75679C14.3483 7.75192 14.3478 7.74713 14.3476 7.74226V6.14467C14.5249 6.01773 14.6374 5.81096 14.6374 5.57903V4.117L16.7522 3.75676C17.0998 3.69756 17.3498 3.42151 17.3743 3.06981C17.3988 2.7181 17.1896 2.41004 16.8536 2.30321L9.72408 0.0354961C9.5753 -0.0118477 9.41817 -0.0118008 9.26949 0.0354492L2.13984 2.30321C1.80389 2.41004 1.59464 2.7181 1.61916 3.06976C1.63472 3.29321 1.7415 3.48587 1.90631 3.61206V5.52395H1.88888C1.48739 5.52395 1.16077 5.85057 1.16077 6.25206V7.20109L0.69075 9.95977C0.609516 10.4369 0.977016 10.8736 1.46217 10.8736H3.05353C3.53761 10.8736 3.90638 10.4379 3.82495 9.95973L3.35494 7.20109V6.25206C3.35494 5.85057 3.02831 5.52395 2.62683 5.52395H2.60944V3.81943L4.35759 4.11718V5.57903C4.35759 5.80998 4.46958 6.01642 4.64602 6.14354L4.64667 7.75693V9.01796C4.64667 9.48282 4.9876 9.86945 5.43258 9.94107C5.54578 11.113 6.15441 12.1355 7.04082 12.8048V13.2655L3.97697 15.2668L2.56955 15.6799C1.0635 16.1219 9.36985e-05 17.5046 9.36985e-05 19.1118V20.1596C9.36985e-05 20.3537 0.157453 20.5111 0.351656 20.5111C0.54586 20.5111 0.703219 20.3538 0.703219 20.1596V19.1118C0.703219 17.8451 1.55208 16.7112 2.76759 16.3545L4.07897 15.9696L9.318 19.0827C9.42436 19.1459 9.56508 19.1492 9.67716 19.0827L14.9165 15.9694L16.2278 16.3543C17.4431 16.7111 18.2919 17.8449 18.2919 19.1116V22.5071C18.2919 22.9426 17.9376 23.297 17.5021 23.297H15.9526V21.7816C15.9526 21.5874 15.7952 21.43 15.601 21.43C15.4068 21.43 15.2494 21.5874 15.2494 21.7816V23.297H3.74405V21.7816C3.74405 21.5874 3.58669 21.43 3.39249 21.43C3.19828 21.43 3.04092 21.5874 3.04092 21.7816V23.297H1.49297C1.05745 23.297 0.703125 22.9426 0.703125 22.5071V21.803C0.703125 21.6088 0.545766 21.4514 0.351563 21.4514C0.157359 21.4514 0 21.6088 0 21.803V22.5071C0 23.3303 0.669703 24 1.49292 24H17.502C18.3252 24 18.9949 23.3303 18.9949 22.5071V19.1116C18.9949 17.5422 17.9678 16.1324 16.4257 15.6796ZM3.05349 10.1705H1.46217C1.413 10.1705 1.3755 10.1266 1.38384 10.0778L1.809 7.58237H2.70666L3.13181 10.0778C3.14011 10.1265 3.10289 10.1705 3.05349 10.1705ZM2.65181 6.25206V6.87929H1.8638V6.25206C1.8638 6.23823 1.875 6.22703 1.88883 6.22703H2.62674C2.64061 6.22698 2.65181 6.23823 2.65181 6.25206ZM8.24016 17.4924L8.38008 17.7075L4.79091 15.5748L7.06908 14.0867C7.17239 15.2989 7.57196 16.4654 8.24016 17.4924ZM8.23772 15.9748C9.06521 16.0924 9.9293 16.0925 10.7573 15.9748C10.5973 16.3685 10.4001 16.7484 10.1655 17.109L9.49749 18.1358L8.82947 17.109C8.59486 16.7484 8.39771 16.3685 8.23772 15.9748ZM10.7548 17.4924C11.423 16.4654 11.8226 15.2989 11.9258 14.0867L14.204 15.5747L10.6149 17.7075L10.7548 17.4924ZM12.8113 6.27559H13.6445V7.40518H13.2309C12.9995 7.40518 12.8112 7.21693 12.8112 6.98551V6.27559H12.8113ZM2.35294 2.97325L9.48267 0.705433C9.49182 0.702527 9.50166 0.70248 9.51094 0.70548L16.6406 2.97325C16.6553 2.97793 16.6756 2.98431 16.673 3.02092C16.6704 3.05748 16.6495 3.061 16.6343 3.06362L14.277 3.4651L13.392 3.35565C13.1994 3.33179 13.0238 3.46876 13 3.66142C12.9762 3.85412 13.1131 4.02962 13.3058 4.05343L13.9343 4.1312V5.57251L5.06067 5.57218V4.13115L8.6985 3.68101C9.22838 3.61553 9.76557 3.61553 10.2951 3.68101L11.6719 3.85131C11.8646 3.87517 12.0401 3.73825 12.064 3.54559C12.0878 3.35289 11.9509 3.17739 11.7583 3.15353L10.3814 2.98323C9.79467 2.91062 9.19936 2.91062 8.61221 2.98323L4.71717 3.4652L2.35922 3.06362C2.34394 3.061 2.32308 3.05748 2.3205 3.02092C2.31797 2.98431 2.33817 2.97789 2.35294 2.97325ZM5.34956 7.40518L5.3491 6.27559H6.18371V6.98556C6.18371 7.21693 5.99546 7.40523 5.76399 7.40523H5.34956V7.40518ZM6.12333 9.76037C6.10524 9.4741 5.8673 9.24985 5.58169 9.24985C5.45377 9.24985 5.34971 9.14579 5.34971 9.01792V8.10831H5.76399C6.38306 8.10831 6.88678 7.60463 6.88678 6.98556V6.27559H12.1081V6.98556C12.1081 7.60463 12.6119 8.10831 13.2309 8.10831H13.6452V9.01792C13.6452 9.14579 13.5412 9.24985 13.4132 9.24985C13.1276 9.24985 12.8897 9.4741 12.8716 9.76042C12.7596 11.5355 11.2775 12.9261 9.49744 12.9261C7.71736 12.9261 6.23531 11.5355 6.12333 9.76037ZM9.49749 13.6291C10.1228 13.6291 10.717 13.4862 11.2496 13.232V13.4548C11.2496 14.0559 11.1685 14.6488 11.0123 15.2206C10.0569 15.4028 8.9768 15.4102 7.98263 15.2206C7.82649 14.6488 7.74539 14.0559 7.74539 13.4548C7.74539 13.4473 7.74436 13.4401 7.74389 13.4327C7.7438 13.4312 7.74394 13.4298 7.74385 13.4283V13.2313C8.27677 13.4859 8.87161 13.6291 9.49749 13.6291Z"
				fill={color}
			/>
		</svg>
	);
};
export {
	RightArrow,
	LeftArrow,
	HomeIcon,
	HomeworkIcon,
	ExamIcon,
	GroupIcon,
	CompetitonIcon,
	MenuIcon,
	LogoutIcon,
	SettingsIcon,
	EyeIcon,
	DownloadIcon,
	DargIcon,
	SortIcon,
	PlusIcon,
	EditIcon,
	DeleteIcon,
	ViewIcon,
	StepIcon,
	ShareIcon,
	SendIcon,
	CopyIcon,
	UserIcon,
	SchoolIcon,
	LocationIcon,
	EmailIcon,
	LockIcon,
	MicIcon,
	StopIcon,
	PlayIcon,
	PauseIcon,
};
